define('collections/goal/goals',[
    'underscore',
    'backbone',
    'mustache',
    'utils',
    // services
    'services/api',
    // superclass
    'src/plugins/infinite-collection',
    // models
    'models/goal/goal'
], function(
    _, Backbone, Mustache, U,
    // services
    API,
    // superclass
    InfiniteCollection,
    // models
    MGoal
) {

    var CGoals = InfiniteCollection.extend({
        model: MGoal,

        state: {
            pageSize: 100,
            sortKey: 'date',
            order: 1,
        },

        // sort by date as UTC string (reverse chronological order)
        comparator: function(a, b) {
            return -a.get('startDate').localeCompare(b.get('startDate'));
        },

        url: function() {
            var url = 'goals/?currentValue';

            if (this.user) {
                url = Mustache.render('users/{{userId}}/' + url, {
                    userId: this.user
                });
            }

            return API.url(url);
        },

        getMostRecent: function() {
            return this.last(2);
        },

        getFirstPage: function(opt) {
            opt = opt || {};
            if (opt.user) this.user = opt.user;
            return CGoals.__super__.getFirstPage.call(this, opt);
        },

    });

    return CGoals;
});

